import { FC } from 'react';
import { useIntl } from 'react-intl';

import { CloseButton } from './buttons';

type ExternalHeaderProps = Readonly<{
  quoteId: string;
  onClosed: () => void;
}>;

export const ExternalTileHeader: FC<ExternalHeaderProps> = ({ quoteId, onClosed }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="d-flex p-2 justify-content-between">
      <div className="d-flex flex-column justify-content-center mt-2 ms-2">
        <h6 className="text-truncate mb-1" title={formatMessage({ id: 'quoteId' })}>
          {quoteId}
        </h6>
      </div>
      <CloseButton onClosed={onClosed} />
    </div>
  );
};
